// Audio control for product pages
(function() {
  function initAudioControl() {
    const audioElements = document.querySelectorAll('.audio-player'); 
    
    if (audioElements.length === 0) return; 
    
    audioElements.forEach(audio => {
      
      audio.removeEventListener('play', handleAudioPlay);
      audio.addEventListener('play', handleAudioPlay);
    });
  }
  
  function handleAudioPlay(event) {
    const currentAudio = event.target;
    const allAudios = document.querySelectorAll('.audio-player'); 
    
    allAudios.forEach(audio => {
      if (audio !== currentAudio && !audio.paused) {
        audio.pause();
        audio.currentTime = 0;
      }
    });
  }
  
  
  if (document.readyState === 'complete') {
    initAudioControl();
  } else {
    document.addEventListener('DOMContentLoaded', initAudioControl);
  }
  
  
  document.addEventListener('shopify:section:load', initAudioControl);
})();